import { Pipe, PipeTransform } from '@angular/core';
import { get } from 'lodash';

export interface FilterObject {
  attributeName: string;
  value: string | number | boolean;
}

@Pipe({ name: 'filter', pure: false })
export class ObjectArrayFilterPipe implements PipeTransform {
  transform<T>(items: T[], ...filters: (FilterObject | undefined)[]): T[] {
    if (!items || !filters?.length) {
      return items;
    }
    return items.filter((item) => {
      for (const f of filters) {
        if (f && !get(item, f.attributeName)?.includes(f.value)) return false;
      }
      return true;
    });
  }
}

@Pipe({ name: 'concat', pure: false })
export class ArrayConcatPipe implements PipeTransform {
  transform<T, U>(array: T[], other: U | U[]): (T | U)[] {
    if (Array.isArray(other)) {
      return (array as (T | U)[]).concat(...other);
    } else {
      return (array as (T | U)[]).concat(other);
    }
  }
}

@Pipe({ name: 'concatIf', pure: false })
export class ArrayConcatConditionalPipe implements PipeTransform {
  transform<T, U>(array: T[], other: U | U[], predicate: any): (T | U)[] {
    if (predicate) {
      if (Array.isArray(other)) {
        return (array as (T | U)[]).concat(...other);
      } else {
        return (array as (T | U)[]).concat(other);
      }
    } else return array;
  }
}
